export const contentStyle: any = {
    carouselProps: {
        slidesToShow: 3,
        dots: false,
        arrows: true,
        draggable: true,
        infinite: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                    infinite: false,
                    dots: true,
                    centerMode: false,
                    centerPadding: '0px',
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: false,
                    centerMode: false,
                    centerPadding: '0%',
                    dots: true,
                    arrows: false,
                },
            },
        ],
    },
};

export const beginnerplanFeatures = ["Unlimited Product Import", "List & Manage up to 5000 Products", "Real-Time Order Syncing (FBA & FBM)", "Automated Price Sync Rules", "Auto-tag orders from Amazon", "Basic Support"];

export const growthPlanFeatures = [ 'Unlimited Product Import', 'List & Manage up to 10000 Products', 'Advance Inventory Management', 'Meta field Support for Amazon Listings', 'Product Optimizer Tool', 'Basic Support'];

export const enterprisePlanFeatures = [ 'List & Manage Unlimited Product', 'Amazon BuyShipping Support', 'Amazon Business (B2B) Support', 'Enterprise Support', 'Advanced Product Optimizer', 'Support for Product Bundles & Multi-Location Inventory (Coming Soon)'];

export const freePlanFeatures = ['Unlimited Product Import', 'List & Manage up to 100 Products', 'Real-time Product and Inventory Sync', 'Limited Features', '50 orders/month; $0.2/order'];

export const basicSupportServices = ["24/7 Email & Chat support", "Limited Access Meetings", "Detailed Onboarding Guide"];

export const enhancedSupportFeatures = ["Enhanced Support Response: 3-6 hrs", "Support Channels: Email, Phone, Google Meet, WhatsApp, or Slack", "Guided Onboarding with a Dedicated Account Manager", "Dedicated Point of Contact (POC) for Issue Resolution", "Product Upload for Either All Products in One Category Template or 30 Products (One-Time)."];

export const premiumSupportFeatures = ["Advanced Support Response: 2-4 hrs", "Proactive Seller Account Health Monitoring and Management", "Optimize up to 10 SKUs(One-Time)", "Priority for Feature Requests and Custom Solutions", "Product Upload Support for either all products in One Category Template or 30 Products/ month. "];

export const enterpriseSupportFeatures = ["Elite Support Response: 1-2 hrs", "Optimize up to 30 SKUs per month, including Ads Management", "Dedicated Marketing POC for Campaign Management", "Product Upload for Either All Products in Two Category Templates or 60 Products/month.", "A+ content for up to 5 SKUs/month with brand story."]